// WFS sourcesDescription population.
// Extracted from rawConfig.ts as part of Phase 4.4.
import {IConfig} from '../../core/interfaces/reducers'
import {ViewSchemaType} from '../../core/enums/ViewSchemaType'

export function populateWfsSources(rawConfig: IConfig, geoserverApiUrl: string): void {
  rawConfig.sourcesDescription[geoserverApiUrl] = {
    serviceType: 'wfs',

    namespaces: {
      MapAccess_CMCRBuildingWMS: {
        cad: {
          layers: {
            0: {
              useLocalDescriptions: true,
              sourceTitle: 'Сгради',
              idField: 'adm_id',
              visible: false,
              addOnMap: true,
              noRegister: true,
              minimumz: 14,
              pseudoViewSchema: {0: ViewSchemaType.None, 14: ViewSchemaType.Image},
              opacity: 1,
              z: 3,
              readOnly: true,
              featureTitle: {bg: 'Сграда кад: {ekatte}.{cadregion}.{cadimmovable}.{cadbuilding}'},
              tableFields: ['cadregion'],
              fieldInfos: {
                adm_id: {
                  type: 'integer',
                  label: {bg: 'id'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                ekatte: {
                  type: 'string',
                  label: {bg: 'ЕКАТТЕ'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadregion: {
                  type: 'integer',
                  label: {bg: 'Кад. регион'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadimmovable: {
                  type: 'integer',
                  label: {bg: 'cadimmovable'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                propertytype: {
                  type: 'string',
                  label: {bg: 'Вид собственост'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                functype: {
                  type: 'string',
                  label: {bg: 'Функционално предназначение'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                floorcount: {
                  type: 'integer',
                  label: {bg: 'Брой етажи'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                geometry: {
                  type: 'geometry',
                  label: {bg: 'geometry'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                appcount: {
                  type: 'integer',
                  label: {bg: 'Брой апартаменти'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                buildingarea: {
                  type: 'integer',
                  label: {bg: 'Площ'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadbuilding: {
                  type: 'integer',
                  label: {bg: 'cadbuilding'},
                  visible: false,
                  nullable: true,
                  editable: false
                }
              }
            }
          }
        }
      },
      MapAccess_CMCRImmovableWMS: {
        cad: {
          layers: {
            0: {
              useLocalDescriptions: true,
              sourceTitle: 'Имоти',
              idField: 'adm_id',
              visible: false,
              addOnMap: true,
              minimumz: 14,
              noRegister: true,
              pseudoViewSchema: {0: ViewSchemaType.None, 14: ViewSchemaType.Image},
              opacity: 1,
              z: 2,
              readOnly: true,
              featureTitle: {bg: 'Имот кад: {ekatte}.{cadregion}.{cadimmovable}'},
              tableFields: ['adm_id'],
              fieldInfos: {
                adm_id: {
                  type: 'integer',
                  label: {bg: 'adm_id'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                geometry: {
                  type: 'geometry',
                  label: {bg: 'geometry'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                ekatte: {
                  type: 'string',
                  label: {bg: 'ЕКАТТЕ'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadregion: {
                  type: 'integer',
                  label: {bg: 'Кад. регион'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadimmovable: {
                  type: 'integer',
                  label: {bg: 'cadimmovable'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                propertytype: {
                  type: 'string',
                  label: {bg: 'Вид собственост'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                purposetype: {
                  type: 'string',
                  label: {bg: 'Предназначение'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                rn_usagetype: {
                  type: 'string',
                  label: {bg: 'Застрояване'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                immarea: {
                  type: 'integer',
                  label: {bg: 'Площ'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                oldident: {
                  type: 'string',
                  label: {bg: 'Стар номер'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                quarter: {
                  type: 'string',
                  label: {bg: 'Квартал'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                parcel: {
                  type: 'string',
                  label: {bg: 'Парцел'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                category: {
                  type: 'integer',
                  label: {bg: 'Категория'},
                  visible: true,
                  nullable: true,
                  editable: false
                }
              }
            },
            1: {
              useLocalDescriptions: true,
              sourceTitle: 'Граници',
              idField: 'adm_id',
              visible: false,
              addOnMap: true,
              minimumz: 14,
              noRegister: true,
              pseudoViewSchema: {0: ViewSchemaType.None, 14: ViewSchemaType.Image},
              opacity: 1,
              z: 2,
              readOnly: true,
              featureTitle: {bg: 'Имот кад: {ekatte}.{cadregion}.{cadimmovable}'},
              tableFields: ['adm_id'],
              fieldInfos: {
                adm_id: {
                  type: 'integer',
                  label: {bg: 'adm_id'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                geometry: {
                  type: 'geometry',
                  label: {bg: 'geometry'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                ekatte: {
                  type: 'string',
                  label: {bg: 'ЕКАТТЕ'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadregion: {
                  type: 'integer',
                  label: {bg: 'Кад. регион'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadimmovable: {
                  type: 'integer',
                  label: {bg: 'cadimmovable'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                propertytype: {
                  type: 'string',
                  label: {bg: 'Вид собственост'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                purposetype: {
                  type: 'string',
                  label: {bg: 'Предназначение'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                rn_usagetype: {
                  type: 'string',
                  label: {bg: 'Застрояване'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                immarea: {
                  type: 'integer',
                  label: {bg: 'Площ'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                oldident: {
                  type: 'string',
                  label: {bg: 'Стар номер'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                quarter: {
                  type: 'string',
                  label: {bg: 'Квартал'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                parcel: {
                  type: 'string',
                  label: {bg: 'Парцел'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                category: {
                  type: 'integer',
                  label: {bg: 'Категория'},
                  visible: true,
                  nullable: true,
                  editable: false
                }
              }
            }
          }
        }
      },
      MapAccess_CMCRApartmentWMS: {
        cad: {
          layers: {
            0: {
              useLocalDescriptions: true,
              sourceTitle: 'Схеми',
              idField: 'appnumber',
              visible: false,
              addOnMap: true,
              constantSqlWhere: "floornumber='1'",
              minimumz: 14,
              noRegister: true,
              pseudoViewSchema: {0: ViewSchemaType.None, 14: ViewSchemaType.Image},
              opacity: 1,
              z: 4,
              readOnly: true,
              featureTitle: {bg: 'Схема: {ekatte}.{cadregion}.{cadimmovable}.{cadbuilding}.{cadapp}'},
              tableFields: ['appnumber'],
              fieldInfos: {
                geometry: {
                  type: 'geometry',
                  label: {bg: 'geometry'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                ekatte: {
                  type: 'string',
                  label: {bg: 'ЕКАТТЕ'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                apparea: {
                  type: 'string',
                  label: {bg: 'Площ'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadregion: {
                  type: 'integer',
                  label: {bg: 'Кад. регион'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadimmovable: {
                  type: 'integer',
                  label: {bg: 'cadimmovable'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                propertytype: {
                  type: 'string',
                  label: {bg: 'Вид собственост'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                apptype: {
                  type: 'string',
                  label: {bg: 'Вид'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                floorcount: {
                  type: 'integer',
                  label: {bg: 'Брой етажи'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                floornumber: {
                  type: 'string',
                  label: {bg: 'Етаж'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                appnumber: {
                  type: 'string',
                  label: {bg: 'Номер'},
                  visible: true,
                  nullable: true,
                  editable: false
                },
                cadbuilding: {
                  type: 'integer',
                  label: {bg: 'cadbuilding'},
                  visible: false,
                  nullable: true,
                  editable: false
                },
                cadapp: {
                  type: 'integer',
                  label: {bg: 'cadapp'},
                  visible: false,
                  nullable: true,
                  editable: false
                }
              }
            }
          }
        }
      }
    }
  }
}
